/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";
import { useDeleteApplication } from "../hooks/useDeleteApplication/useDeleteApplication";

type Props = {
  applicationId: string;
  name: string;
};

export function ApplicationDelete({ applicationId, name }: Props) {
  const { isOpen, close, open: openModal } = useDisclosure(false);

  const [deleteApplication] = useDeleteApplication({
    onSuccess: () => {
      close();
    },
  });

  const onDelete = async () => {
    await deleteApplication(applicationId);
  };

  return (
    <>
      <Button
        aria-label="delete button"
        icon="trash"
        size="md"
        severity="low"
        onClick={openModal}
      />
      <When condition={isOpen}>
        <ModalConfirm
          onClose={close}
          isOpen={isOpen}
          confirm={() => onDelete()}
          actionLabel="Delete"
          data-testid="modal-application-delete"
          contentLabel={"Delete Application"}
        >
          Are you sure you want to delete <b>{`${name}`}</b>?
        </ModalConfirm>
      </When>
    </>
  );
}
